import isEmpty from 'hs-lodash/isEmpty';
export const hasIntersection = function hasIntersection(array1, array2) {
  if (isEmpty(array1) || isEmpty(array2)) {
    return false;
  }

  const [shortest, longest] = array1.length <= array2.length ? [array1, array2] : [array2, array1];
  return shortest.some(data => longest.indexOf(data) > -1);
};